import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './Modal.scss'

export default function Modal({ children, open, onClose, className = '' }) {
    const [displayed, setDisplayed] = useState("none");
    useEffect(() => {
        if (open) setDisplayed("block");
        else setDisplayed("none");
    }, [open]);

    return createPortal(
        <div className="modal-overlay" onClose={onClose}
            style={{ display: displayed }}>
            <div className="modal-container">
                <div className={`appmodal ${className}`} >
                    {children}
                </div>
            </div>
        </div>, document.getElementById('modal')
    )
}